import { useState, useEffect } from 'react';
import axios from 'axios';
import PageError from '../common_component/PageError.js';
import { useAuthData } from "./auth-provider.js"
import swal from 'sweetalert';
import { getCookie } from '../common_component/cookie.js';
import Select from 'react-select';
import { useTheme } from "./theme-provider.js";
import { useLocation } from 'react-router-dom';
import { Table, Input, Button, Card, Popconfirm, Tooltip } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useModal } from '../providers/modal-provider.js';
import country_arr from './common_arr/countries-arr.js';
import s_a from './common_arr/states-arr.js';

export const AddBulkData = () => {
    const [state, setstate] = useState(1);
    const { openModal, setModalView, setModalData } = useModal();
    const { theme, dropdownStyleDark } = useTheme();
    const location = useLocation();

    const [bulkDataSubmitButtonState, setBulkDataSubmitButtonState] = useState(false)
    const [selectedBulkDataFor, setSelectedBulkDataFor] = useState(null)
    const [selectedBulkDataType, setSelectedBulkDataType] = useState(null)

    var page_name = "add-bulk-data";

    const [categoryOptions, setCategoryOptions] = useState([]);

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(0);

    const [fieldData, setFieldData] = useState({
        Category: [{
            title: "Category Name",
            dataIndex: "category_name",
            required: true,
            uniqueKey: true,
            field_type: "input"
        },
        {
            title: "Category Code",
            dataIndex: "category_code",
            required: true,
            uniqueKey: true,
            field_type: "input"
        },
        {
            title: "Description",
            dataIndex: "category_description",
            required: false,
            field_type: "input"
        }],
        Subcategory: [{
            title: "Subcategory Name",
            dataIndex: "subcategory_name",
            required: true,
            uniqueKey: true,
            field_type: "input"
        },
        {
            title: "Subcategory Code",
            dataIndex: "subcategory_code",
            required: true,
            uniqueKey: true,
            field_type: "input"
        },
        {
            title: "Select Category",
            dataIndex: "category",
            required: true,
            searchable: true,
            field_type: "select",
            options: []
        },
        {
            title: "Description",
            dataIndex: "subcategory_description",
            required: false,
            field_type: "input"
        }],
        Brand: [{
            title: "Brand Name",
            dataIndex: "brand_name",
            required: true,
            uniqueKey: true,
            field_type: "input"
        },
        {
            title: "Description",
            dataIndex: "brand_description",
            required: false,
            field_type: "input"
        }],
        Item: [{
            title: "Product Type",
            dataIndex: "product_type",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['Goods', 'Service']
        },
        {
            title: "Product Name",
            dataIndex: "product_name",
            uniqueKey: true,
            required: true,
            field_type: "input"
        },
        {
            title: "Category",
            dataIndex: "category",
            required: false,
            searchable: true,
            field_type: "select",
            options: [],
            isLoading: false
        },
        {
            title: "Subategory",
            dataIndex: "subcategory",
            required: false,
            searchable: true,
            field_type: "select",
            options: [],
            isLoading: false
        },
        {
            title: "Brand",
            dataIndex: "brand",
            required: false,
            searchable: true,
            field_type: "select",
            options: [],
            isLoading: false,
        },
        {
            title: "Usage Unit",
            dataIndex: "usage_unit",
            required: true,
            searchable: false,
            field_type: "select",
            options: ["Box", "Centimeter", "Dozen", "Feet", "Grams", "Inches", "Pound", "Pieces"].map((item, index) => ({ value: index + 1, label: item }))
        }, {
            title: "Track Inventory",
            dataIndex: "track_inventory",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['Goods', 'Service']
        }, {
            title: "Inventory Type",
            dataIndex: "tracking_inventory_type",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['Quantity', 'Track Serial Number', 'Track Batches']
        }, {
            title: "Tax Preference",
            dataIndex: "tax_preference",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['Taxable', 'Non Taxable', 'Out of Scope', 'Non-GST Supply']
        }, {
            title: "Calculation Method",
            dataIndex: "tax_calculation_method",
            required: true,
            searchable: false,
            field_type: "select",
            options: [{ label: 'Tax Exclusive', value: 'Tax_Exclusive' }, { label: 'Tax Inclusive', value: 'Tax_Inclusive' }]
        }, {
            title: "Intra State Tax",
            dataIndex: "intra_state_tax",
            required: true,
            searchable: false,
            field_type: "select",
            options: []
        }, {
            title: "Inter State Tax",
            dataIndex: "inter_state_tax",
            required: true,
            searchable: false,
            field_type: "select",
            options: []
        }],
        Customer: [{
            title: "Customer Type",
            dataIndex: "customer_type",
            required: true,
            searchable: false,
            field_type: "select",
            options: [{ label: 'Business', value: 'business' }, { label: 'Individual', value: 'individual' }]
        },
        {
            title: "Salutation",
            dataIndex: "salutation",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['Mr.', 'Mrs.', 'Miss.', 'Dr.', 'M/s', 'Prof.']
        },
        {
            title: "First Name",
            dataIndex: "first_name",
            required: true,
            field_type: "input"
        },
        {
            title: "Last Name",
            dataIndex: "last_name",
            required: true,
            field_type: "input"
        },
        {
            title: "Work Phone",
            dataIndex: "work_phone",
            uniqueKey: true,
            required: true,
            field_type: "input"
        },
        {
            title: "Email",
            dataIndex: "email",
            uniqueKey: true,
            required: false,
            field_type: "input"
        },
        {
            title: "Lead Source",
            dataIndex: "lead_source",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['CRM', 'Websites', 'Social', 'Referral', 'Cold Call', 'SEO']
        },
        {
            title: "Gst Treatment",
            dataIndex: "gst_treatment",
            required: true,
            searchable: false,
            field_type: "select",
            options: ['Unregistered']
        },
        {
            title: "Place Supply",
            dataIndex: "place_supply",
            required: true,
            searchable: false,
            field_type: "select",
            options: []
        },
        {
            title: "Currency",
            dataIndex: "currency",
            required: true,
            searchable: false,
            field_type: "select",
            options: []
        }, {
            title: "Country",
            dataIndex: "country",
            required: true,
            searchable: false,
            field_type: "select",
            options: []
        }, {
            title: "State",
            dataIndex: "state",
            required: true,
            searchable: false,
            field_type: "select",
            options: []
        }, {
            title: "Address Line1",
            dataIndex: "address_line1",
            required: true,
            field_type: "input"
        }, {
            title: "City",
            dataIndex: "city",
            required: true,
            field_type: "input"
        }, {
            title: "Pin Code",
            dataIndex: "pin_code",
            required: true,
            field_type: "input"
        }],
    });

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const getcategorydetails = async (search_value) => {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-category-by-search`,
            {
                method: "POST",
                body: JSON.stringify({
                    email: user.email,
                    search_value: search_value,
                    page_name,
                    organization_id,
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    token: getCookie("access_token"),
                },
            }
        );
        const body = await response.json();
        if (body.operation === "success") {
            return body.data.list.map(item => ({
                label: item.category_name,
                value: item.id
            }));
        }
        return [];
    };

    const getbranddetails = async (search_value) => {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get-brands-by-search`, {
            method: "POST",
            body: JSON.stringify({ email: user.email, search_value: search_value, page_name, organization_id }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                token: getCookie("access_token"),
            },
        });
        const body = await response.json();
        if (body.operation === "success") {
            return body.data.list.map(item => ({
                label: item.brand_name,
                value: item.brand_id
            }));
        }
        return [];
    };

    const getsubcategorydetails = async (search_value, category) => {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get-subcategory-by-search`, {
            method: "POST",
            body: JSON.stringify({ email: user.email, category: category, search_value: search_value, page_name, organization_id }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                token: getCookie("access_token"),
            },
        });
        const body = await response.json();
        if (body.operation === "success") {
            return body.data.list.map(item => ({
                label: item.subcategory_name,
                value: item.id
            }));
        }
        return [];
    };

    const getcurrencydetails = async () => {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/currency-datatable`, {
            method: "POST",
            body: JSON.stringify({ email: user.email, page_name, organization_id }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                token: getCookie("access_token"),
            },
        });
        const body = await response.json();
        if (body.operation === "success") {
            return body.data.map(item => ({
                label: item.currency_code,
                value: item.currency_id
            }));
        }
        return [];
    };

    async function gettaxgroupdetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/tax-group-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if ((body.operation === "success") && (body.data.length > 0)) {
            return body.data;
        }
    }

    const updateFieldOptions = (module, fieldKey, options) => {
        setFieldData(prev => {
            const updatedFields = prev[module].map(field => {
                if (field.dataIndex === fieldKey) {
                    return {
                        ...field,
                        options
                    };
                }
                return field;
            });
            return {
                ...prev,
                [module]: updatedFields
            };
        });
    };

    useEffect(() => {
        if ((read || write) && user.email && visibility && selectedBulkDataType === "Manual") {
            if (selectedBulkDataFor === "Subcategory") {
                getcategorydetails().then(setCategoryOptions).then(options => {
                    updateFieldOptions("Subcategory", "category", options);
                });
            }
            else if (selectedBulkDataFor === "Item") {
                Promise.all([
                    getbranddetails(),
                    getcategorydetails(),
                    //getsubcategorydetails(),
                    gettaxgroupdetails()
                ]).then(([brandOptions, categoryOptions, taxGroupDetails]) => {
                    updateFieldOptions("Item", "brand", brandOptions);
                    updateFieldOptions("Item", "category", categoryOptions);
                    //updateFieldOptions("Item", "subcategory", subcategoryOptions);
                    const intraStateTax = taxGroupDetails.filter(x => x.tax_group_type === "INTRASTATE").map(x => { return { label: `(${x.tax_group_percentage}%) ${x.tax_group_name}`, value: x.tax_group_id } });
                    const interStateTax = taxGroupDetails.filter(x => x.tax_group_type === "INTERSTATE").map(x => { return { label: `(${x.tax_group_percentage}%) ${x.tax_group_name}`, value: x.tax_group_id } });
                    updateFieldOptions("Item", "inter_state_tax", interStateTax);
                    updateFieldOptions("Item", "intra_state_tax", intraStateTax);
                });
            }
            else if (selectedBulkDataFor === "Customer") {
                let selectedCountryIndex = 0;
                country_arr.country_arr.map((obj, index) => {
                    if (obj == "India") {
                        selectedCountryIndex = index;
                    }
                })
                const country_array = country_arr.country_arr.slice(1).map(obj => ({ label: obj, value: obj }));
                const state_array = s_a.s_a[selectedCountryIndex].split("|").map(state => ({ value: state, label: state }));
                updateFieldOptions("Customer", "country", country_array);
                updateFieldOptions("Customer", "place_supply", state_array);
                getcurrencydetails().then(currencyOptions => {
                    updateFieldOptions("Customer", "currency", currencyOptions);
                });
            }
        }
    }, [user, visibility, read, write, selectedBulkDataFor, selectedBulkDataType]);

    useEffect(() => {
        if (location.state) {
            setSelectedBulkDataType("Manual");
            setSelectedBulkDataFor(location.state.excel_for)
        }
    }, [location])

    const loadSubcategoryOptions = async (categoryId) => {
        const subcategories = await getsubcategorydetails("", categoryId);
        updateFieldOptions("Item", "subcategory", subcategories);
    };

    function loadStateOptions(country) {
        let selectedCountryIndex = country_arr.country_arr.findIndex(obj => obj === country);

        let state_array = selectedCountryIndex > -1
            ? s_a.s_a[selectedCountryIndex].split("|").map(state => ({ value: state, label: state }))
            : []; // Handle the case where no country is found.
        updateFieldOptions("Customer", "state", state_array);
    }

    // Handle Cell Change
    const handleInputChange = (val, key, field) => {
        setDataSource((prevDataSource) =>
            prevDataSource.map((item) => {
                if (item.key === key) {
                    const updatedItem = { ...item, [field]: val };

                    // Handle country -> clear state
                    if (field === "country") {
                        updatedItem.state = null;
                        loadStateOptions(val?.value);
                    }

                    // Handle category -> clear subcategory
                    if (field === "category") {
                        updatedItem.subcategory = null;
                        loadSubcategoryOptions(val?.value);
                    }

                    // Handle tax_preference -> clear related tax fields if Non Taxable
                    if (field === "tax_preference" && val === "Non Taxable") {
                        updatedItem.tax_calculation_method = null;
                        updatedItem.intra_state_tax = null;
                        updatedItem.inter_state_tax = null;
                    }

                    return updatedItem;
                }
                return item;
            })
        );
    };

    // Add Row
    const handleAddRow = () => {
        let newRow = { key: count, editable: true };

        // Dynamically build fields based on form_table_data
        fieldData[selectedBulkDataFor].forEach(({ dataIndex }) => {
            newRow[dataIndex] = ""; // initialize as empty string or default value
        });

        setDataSource([...dataSource, newRow]);
        setCount(count + 1);
    };

    // Delete Row
    const handleDeleteRow = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const renderInputField = (text, record, dataIndex, isError) => (
        <Input
            style={{
                width: '100%',
                padding: '0 6px',
                height: 32,
                backgroundColor: isError ? '#fff1f0' : '#fff',
                borderColor: isError ? 'red' : undefined,
            }}
            value={text}
            onChange={(e) => handleInputChange(e.target.value, record.key, dataIndex)}
            status={isError ? "error" : ""}
            placeholder={isError ? "Required" : ""}
            size="small"
        />
    );

    const renderSelectField = (
        text,
        record,
        dataIndex,
        isError,
        options,
        searchable,
        isLoading = false, // Add this prop for loading indicator,
        disabled = false
    ) => {
        const commonStyles = {
            control: (base, state) => ({
                ...base,
                minHeight: 32,
                height: 32,
                backgroundColor: disabled ? '#f5f5f5' : (isError ? '#fff1f0' : '#fff'),
                borderColor: disabled ? '#d9d9d9' : (isError ? 'red' : base.borderColor),
                boxShadow: disabled ? 'none' : (isError ? '0 0 0 1px red' : state.isFocused ? base.boxShadow : 'none'),
                cursor: disabled ? 'not-allowed' : 'default',
                opacity: disabled ? 0.6 : 1,
            }),
            container: (base) => ({ ...base, width: '100%' }),
            indicatorsContainer: (base) => ({ ...base, height: 32 }),
            valueContainer: (base) => ({ ...base, padding: '0 8px', height: 32 }),
            input: (base) => ({ ...base, margin: 0, padding: 0 }),
            menuPortal: base => ({ ...base, zIndex: 9999 }),
        };

        const selectedValue = typeof text === 'object' && text !== null
            ? text
            : options?.find(opt => String(opt.value) === String(text)) || (text ? { label: String(text), value: String(text) } : null);

        const handleChange = async (selected) => {
            const { key } = record; // Assuming 'record' is accessible in this scope

            // 3. Update the current field's value
            handleInputChange(selected, key, dataIndex);
        };

        const handleInputSearch = (inputValue) => {
            if (searchable) {
                handleSearchableFieldChange(inputValue, record, dataIndex, selectedBulkDataFor);
            }
        };

        return (
            <Select
                isDisabled={disabled}
                value={selectedValue}
                options={options}
                onChange={handleChange}
                onInputChange={(val) => {
                    if (val.length > 1) {
                        handleInputSearch(val);
                    }
                }}
                isSearchable={searchable}
                isLoading={isLoading} // <-- add loader support
                getOptionLabel={(e) => e.label}
                getOptionValue={(e) => e.value}
                styles={commonStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
            />
        );
    };

    const handleSearchableFieldChange = async (inputValue, record, dataIndex, section) => {
        // Start loading for the specific field in the correct section
        setFieldData(prev => ({
            ...prev,
            [section]: prev[section].map(field =>
                field.dataIndex === dataIndex
                    ? { ...field, isLoading: true }
                    : field
            )
        }));

        // Trigger the async loader
        const loader = loadOptionsByField[dataIndex];
        if (typeof loader === 'function') {
            const updatedOptions = await loader(inputValue, record);
            updateFieldOptions(section, dataIndex, updatedOptions);
        }

        // Stop loading after fetching
        setFieldData(prev => ({
            ...prev,
            [section]: prev[section].map(field =>
                field.dataIndex === dataIndex
                    ? { ...field, isLoading: false }
                    : field
            )
        }));
    };

    const loadOptionsByField = {
        brand: async (inputValue) => {
            return getbranddetails(inputValue);
        },
        category: async (inputValue) => {
            return getcategorydetails(inputValue);
        },
        subcategory: async (inputValue, record) => {
            console.log("abc")
            const category = record?.category;
            const categoryId = typeof category === 'object' ? category?.value : category;
            if (!categoryId) return [];
            return getsubcategorydetails(inputValue, categoryId);
        }
        // add more if needed
    };

    const getColumnsByType = () => {
        if (!selectedBulkDataFor) return [];

        return fieldData[selectedBulkDataFor].map(({ title, dataIndex, required, field_type, options, searchable, isLoading }) => {
            const normalizedOptions = Array.isArray(options)
                ? options.map(opt =>
                    typeof opt === 'object' && opt !== null
                        ? opt
                        : { label: opt, value: opt }
                )
                : [];

            return {
                title,
                dataIndex,
                render: (text, record) => {
                    let isDisabled = false;
                    if (selectedBulkDataFor === "Item") {
                        const taxPref = record.tax_preference.value;
                        isDisabled = ['tax_calculation_method', 'intra_state_tax', 'inter_state_tax'].includes(dataIndex) &&
                            taxPref === 'Non Taxable';
                    }

                    // If field is disabled, no error should be applied
                    const isError = !isDisabled && required && (typeof text === 'string' ? !text.trim() : !text);

                    return field_type === 'select'
                        ? renderSelectField(
                            text,
                            record,
                            dataIndex,
                            isError,
                            normalizedOptions,
                            searchable,
                            isLoading,
                            isDisabled
                        )
                        : renderInputField(text, record, dataIndex, isError);
                }
            };
        });
    };

    const validateFinalSubmit = (data) => {
        if (data.length > 50) {
            swal("Oops!", "You can't add more than 50 entries.", "error");
            return false;
        }

        const requiredFields = fieldData[selectedBulkDataFor]
            ?.filter((field) => field.required)
            .map((field) => field.dataIndex) || [];

        const uniqueKeyFields = fieldData[selectedBulkDataFor]
            ?.filter((field) => field.uniqueKey)
            .map((field) => field.dataIndex) || [];

        const duplicates = new Set();
        let errors = [];

        for (let i = 0; i < data.length; i++) {
            const row = data[i];

            // Check required fields
            for (const field of requiredFields) {
                if (!row[field] || !row[field].toString().trim()) {
                    const absolute_field = field.toLowerCase()
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    errors.push(`Row ${i + 1}: "${absolute_field}" is required.`);
                }
            }

            // 📞 Phone number validation
            if (row.work_phone && !/^\d{6,15}$/.test(row.work_phone)) {
                errors.push(`Row ${i + 1}: "Work Phone" must be 6-15 digits.`);
            }

            // 📧 Email validation
            if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
                errors.push(`Row ${i + 1}: "Email" format is invalid.`);
            }

            // 📮 Pincode validation (Assuming Indian 6-digit pin codes)
            if (row.pin_code && !/^\d{6}$/.test(row.pin_code)) {
                errors.push(`Row ${i + 1}: "Pin Code" must be a 6-digit number.`);
            }

            // Check duplicates only if all unique key fields are non-blank
            if (uniqueKeyFields.length > 0) {
                const keyParts = uniqueKeyFields.map((field) => (row[field] || "").trim().toLowerCase());

                const isKeyBlank = keyParts.every(part => part === "");
                if (!isKeyBlank) {
                    const uniqueKey = keyParts.join("|");

                    if (duplicates.has(uniqueKey)) {
                        errors.push(`Row ${i + 1}: Duplicate entry found.`);
                    } else {
                        duplicates.add(uniqueKey);
                    }
                }
            }
        }

        if (errors.length > 0) {
            swal("Oops!", errors.join("\n"), "error");
            return false;
        }

        return true;
    };

    const manualBulkDataEntry = () => {
        let object = {};
        if (!validateFinalSubmit(dataSource)) {
            return;
        }
        object.bulk_data = dataSource.map(obj => {
            const newObj = {};
            for (const key in obj) {
                const val = obj[key];
                newObj[key] = (val && typeof val === 'object' && 'value' in val) ? val.value : val;
            }
            return newObj;
        });
        object.excel_for = selectedBulkDataFor;
        object.organization_id = organization_id
        object.page_name = page_name;

        //setBulkDataSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/manual-bulk-data-entry`, object, headers).then((res) => {
            setBulkDataSubmitButtonState(false)
            if (res.data.operation === "duplicate_records" && res.data.data && res.data.data.length > 0) {
                let duplicateMessage = "The following ";
                const duplicateDetails = [];

                res.data.data.forEach(duplicateInfo => {
                    duplicateDetails.push(`${duplicateInfo.key} (${duplicateInfo.duplicate_arr.join(', ')})`);
                });

                duplicateMessage += duplicateDetails.length > 1 ? "fields have duplicates: " : "field has duplicates: ";
                duplicateMessage += duplicateDetails.join('; ');

                swal("Duplicate Records Found", duplicateMessage, "warning")
                    .then((value) => {
                        if (value) {
                            // User clicked OK
                            window.location.reload();
                        }
                    });
            }
            else if (res.data.operation === "success") {
                swal("Great!", "Bulk data(manual) added successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const dynamicColumns = [
        {
            title: 'Sl. No.',
            dataIndex: 'key',
            render: (_, __, index) => index + 1,
            width: 80,
            align: 'center',
        },
        ...getColumnsByType(),
        {
            title: "",
            dataIndex: "actions",
            render: (_, record) => (
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDeleteRow(record.key)}>
                    <Button type="danger" icon={<DeleteOutlined />} />
                </Popconfirm>
            ),
        },
    ];

    const handlePaste = (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('Text'); // plain text

        if (!pastedData.trim()) return; // Empty paste, ignore

        const rows = pastedData.trim().split('\n');
        const parsedRows = rows.map(row => row.split('\t')).filter(cols => cols.length > 0);

        // Get editable columns (exclude non-data columns)
        const editableColumns = dynamicColumns.filter(col => col.dataIndex !== 'key' && col.dataIndex !== 'actions');

        const newData = parsedRows.map((cols, index) => {
            let rowData = { key: Date.now() + '-' + index }; // Unique key
            editableColumns.forEach((col, colIndex) => {
                rowData[col.dataIndex] = cols[colIndex] ? cols[colIndex].trim() : '';
            });
            return rowData;
        });

        if (newData.length === 1 && newData[0][editableColumns[0]?.dataIndex]) {
            // Single keyword paste: put into first editable cell of first row
            setDataSource(prev => {
                if (prev.length === 0) {
                    // If table empty, create new row
                    return [{
                        key: Date.now(),
                        [editableColumns[0].dataIndex]: newData[0][editableColumns[0].dataIndex]
                    }];
                } else {
                    // Else update first row
                    const updated = [...prev];
                    updated[0][editableColumns[0].dataIndex] = newData[0][editableColumns[0].dataIndex];
                    return updated;
                }
            });
        } else if (newData.length > 0) {
            // Multi-line paste: append rows
            setDataSource(prev => [...prev, ...newData]);
        }
    };


    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Add Bulk Data</h1>
                    <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/add_bulk_data`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row m-2">
                                    <div className='col-md-4'>
                                        <Select
                                            options={["Excel", "Manual"].map(x => { return { label: x, value: x } })}
                                            onChange={(val) => {
                                                setSelectedBulkDataType(val.value);
                                                setDataSource([]);
                                            }}
                                            value={selectedBulkDataType !== null ? { label: selectedBulkDataType, value: selectedBulkDataType } : null}
                                            placeholder="Bulk Data Type..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                            isDisabled={location.state}
                                        />
                                        {selectedBulkDataType === null && (
                                            <div className="text-danger px-3">
                                                Please select a type to continue.
                                            </div>
                                        )}
                                    </div>
                                    <div className='col-md-4'>
                                        <Select
                                            options={["Brand", "Category", "Subcategory", "Item", "Customer"].map(x => { return { label: x, value: x } })}
                                            onChange={(val) => {
                                                setSelectedBulkDataFor(val.value);
                                                setDataSource([]);
                                            }}
                                            value={selectedBulkDataFor !== null ? { label: selectedBulkDataFor, value: selectedBulkDataFor } : null}
                                            placeholder="Bulk Data For..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                            isDisabled={location.state}
                                        />
                                        {selectedBulkDataFor === null && (
                                            <div className="text-danger px-3">
                                                Please select Bulk Data For to continue.
                                            </div>
                                        )}
                                    </div>
                                    {(selectedBulkDataType === "Excel" && selectedBulkDataFor !== null) &&
                                        <>
                                            <div className='col-md-3'>
                                                <div className='d-flex flex-wrap gap-2'>
                                                    <button className="btn btn-sm btn-primary btn-hover-scale"
                                                        onClick={() => {
                                                            setModalData({
                                                                organization_id: organization_id,
                                                                email: user.email,
                                                                default_active_key: "1",
                                                                excel_for: selectedBulkDataFor,
                                                                page_name,
                                                            })
                                                            setModalView("BULK_UPLOAD_MODAL")
                                                            openModal()
                                                        }}
                                                    >Add In Bulk</button>
                                                    <button className="btn btn-sm btn-primary btn-hover-scale"
                                                        onClick={() => {
                                                            setModalData({
                                                                organization_id: organization_id,
                                                                email: user.email,
                                                                default_active_key: "2",
                                                                excel_for: selectedBulkDataFor,
                                                                page_name,
                                                            })
                                                            setModalView("BULK_UPLOAD_MODAL")
                                                            openModal()
                                                        }}
                                                    >Upload History</button>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                                {selectedBulkDataFor !== null && selectedBulkDataType === "Manual" &&
                                    <>
                                        <style>
                                            {`
                                                .editable-row td {
                                                    padding: 1px !important;
                                                }

                                                .editable-row .ant-input {
                                                    height: 28px;
                                                    padding: 0 6px;
                                                }

                                                .editable-row .ant-select-selector {
                                                    height: 32px !important;
                                                    padding: 0 8px !important;
                                                    display: flex;
                                                    align-items: center;
                                                }
                                            `}
                                        </style>
                                        <div
                                            onPaste={handlePaste}
                                            tabIndex={0} // allow div to receive focus
                                            style={{ outline: 'none' }}
                                        >
                                            <Card
                                                type="inner"
                                                title={`Manual Data Entry - ${selectedBulkDataFor}`}
                                                extra={
                                                    <Button
                                                        type="dashed"
                                                        icon={<PlusOutlined />}
                                                        onClick={handleAddRow}
                                                        style={{
                                                            background: "#f0f2f5",
                                                            borderStyle: "dashed",
                                                            color: "#1890ff",
                                                        }}
                                                    >
                                                        Add Row
                                                    </Button>
                                                }>
                                                <Table
                                                    bordered
                                                    size="middle"
                                                    dataSource={dataSource}
                                                    columns={dynamicColumns}
                                                    rowKey="key"
                                                    pagination={dataSource.length > 10}
                                                    scroll={{ x: Math.max(dynamicColumns.length * 150, 800), y: 400 }}
                                                    style={{
                                                        background: '#fff',
                                                        border: '1px solid #f0f0f0',
                                                    }}
                                                    rowClassName={() => 'editable-row'}
                                                />
                                                {dataSource.length > 0 &&
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                                        <Button
                                                            type="primary"
                                                            loading={bulkDataSubmitButtonState}
                                                            onClick={manualBulkDataEntry}
                                                        >Submit
                                                        </Button>
                                                    </div>}
                                            </Card></div></>}
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>
        </>
    );
};

export default AddBulkData;
